import { Inject, Pipe, PipeTransform } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { OptimizedImageOptions } from '@/offer/offer.model';

export interface OptimizationSettings {
	mode?: string;
	width?: number;
}

@Pipe({
	name: 'optimizedImage',
})
export class OptimizedImagePipe implements PipeTransform {
	constructor(@Inject(DOCUMENT) private readonly document: Document) {}
	transform(value: string, pipeOptions?: OptimizationSettings): string {
		const url = new URL(value);

		const fileName = url.pathname.slice(1);
		const domain = url.origin;

		const requestedWidth = pipeOptions?.width ?? 1500;
		const bucketedWidth = this.mapWidthToBucket(requestedWidth);

		const options: OptimizedImageOptions = {
			key: fileName,
			edits: {
				resize: {
					width: bucketedWidth,
					fit: 'inside',
				},
				toFormat: 'webp',
				webp: {
					quality: 75,
					lossless: false,
					smartSubsample: true,
				},
			},
		};

		if (!!pipeOptions && pipeOptions?.mode === 'print') {
			options.edits.resize = {
				width: 300,
				height: 400,
				fit: 'contain',
			};
		}
		return `${domain}/${btoa(JSON.stringify(options))}`;
	}

	private mapWidthToBucket(imageWidth: number): number {
		switch (true) {
			case imageWidth <= 320:
				return 320;
			case imageWidth <= 480:
				return 480;
			case imageWidth <= 640:
				return 640;
			case imageWidth <= 768:
				return 768;
			case imageWidth <= 1024:
				return 1024;
			case imageWidth <= 1280:
				return 1280;
			case imageWidth <= 1600:
				return 1500;
			default:
				return 1920;
		}
	}
}
